(function (Cobalt) {
    var Footer = /** @class */ (function () {
        function Footer() {
        }
        Footer.initialize = function () {
            Footer.SiteMain = document.querySelector('div#site-main');
            Footer.FooterPush = document.querySelector('div#footer-push');
            Footer.FooterContainer = document.querySelector('footer#footer');
            Footer.FooterHeight = Footer.FooterContainer ? Footer.FooterContainer.offsetHeight : 0;
            Footer.timeoutLength = 500;
            
            if (Footer.SiteMain && Footer.FooterPush && Footer.FooterContainer) {
                window.setTimeout(resize, Footer.timeoutLength);

                window.addEventListener('resize', function () {
                    window.clearTimeout(Footer.resizeTimer);
                    Footer.resizeTimer = window.setTimeout(resize, Footer.timeoutLength);
                });
            }
        };

        function resize() {
            Footer.SiteMain.style.marginBottom = (Footer.FooterHeight * -1) + 'px !important';
            Footer.FooterPush.style.height = Footer.FooterHeight + 'px !important';
        }

        function getFooterHeight() {
            return Footer.FooterContainer ? Footer.FooterContainer.offsetHeight : 0;
        }
        
        return Footer;
    }());
    Cobalt.Footer = Footer;
})(Cobalt || (window.Cobalt = {}));



// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Footer.js